var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _vm._m(0)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticStyle:{"padding-top":"150px"}},[_c('h1',{staticStyle:{"text-align":"center","font-size":"50px"}},[_vm._v("系统正在开发，请耐心等待......")])])}]

export { render, staticRenderFns }